import React from 'react';
import { Switch, Route, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import EmailSentSuccessContainer from '../Screens/RecoverPassword/Screens/EmailSentSuccess.container';
import { LoginUSC } from '../Screens/Login/';
import PasswordResetSuccessContainer from '../Screens/RecoverPassword/Screens/PasswordResetSuccess.container';
import PublicLayoutContainer from '../Layout/PublicLayout/PublicLayout.container';
import PublicRoute from './PublicRoute.component';
import { Route as NeoRoute } from '../Constants/Routes.constants';
import RecoverPassswordNewPasswordContainer from '../Screens/RecoverPassword/RecoverPasswordNewPassword.container';
import RecoverPasswordEmailContainer from '../Screens/RecoverPassword/RecoverPasswordEmail.container';
import { ContextWrapper } from './ContextWrapper';
import { OrganisationRoutes } from './OrganisationRoutes/OrganisationRoutes';
import { OrganisationContextWrapper, useLocalStorage, useNavigation } from '~/Hooks';
import { Onboarding, OnboardingConfirmation, OnboardingPostLogin } from '~/Screens/Onboarding';
import PrivateRoutes from './PrivateRoutes';
import { ExportRedirect } from '~/Screens/Exports';

const {
  ONBOARDING,
  ONBOARDING_OLD,
  HOME,
  LOGIN,
  LOGIN_USC,
  NEW_PASSWORD,
  NEW_PASSWORD_SUCCESS,
  RECOVER_PASSWORD,
  RECOVER_PASSWORD_SUCCESS,
  ACCOUNT_CONFIRMATION,
  PROVIDER_ROOT,
  ORGANISATION_ROOT,
  ONBOARDING_POSTLOGIN,
  POSTLOGIN_ROOT,
  BASE_EXPORT_ROUTE,
} = NeoRoute;

export default () => {
  const loc = useLocation();
  const { navigate } = useNavigation();
  const { setRedirectUrl } = useLocalStorage();
  const matchRedirectTemplate = useRouteMatch<{ url?: string }>({
    path: NeoRoute.REDIRECT,
    location: loc,
  });
  if (matchRedirectTemplate?.params?.url) {
    setRedirectUrl(`${matchRedirectTemplate?.params?.url}${loc.search}`);
    navigate(HOME);
  }
  return (
    <Switch>
      <PublicRoute component={Onboarding} path={ONBOARDING} />
      <PublicRoute component={LoginUSC} path={ONBOARDING_OLD} />
      <PublicRoute exact component={OnboardingConfirmation} path={ACCOUNT_CONFIRMATION} />
      <Route path={POSTLOGIN_ROOT}>
        <ContextWrapper>
          <Route component={OnboardingPostLogin} exact path={ONBOARDING_POSTLOGIN} />
        </ContextWrapper>
      </Route>
      <Route path={PROVIDER_ROOT}>
        <ContextWrapper>
          <PrivateRoutes />
        </ContextWrapper>
      </Route>
      <Route path={ORGANISATION_ROOT}>
        <ContextWrapper>
          <OrganisationContextWrapper>
            <OrganisationRoutes />
          </OrganisationContextWrapper>
        </ContextWrapper>
      </Route>
      <Route path={BASE_EXPORT_ROUTE}>
        <ContextWrapper>
          <Route component={ExportRedirect} path={BASE_EXPORT_ROUTE} />
        </ContextWrapper>
      </Route>
      <PublicRoute component={LoginUSC} exact path={LOGIN_USC} />
      <PublicRoute component={LoginUSC} exact path={LOGIN} />

      <PublicRoute
        component={PasswordResetSuccessContainer}
        layout={PublicLayoutContainer}
        path={NEW_PASSWORD_SUCCESS}
      />
      <PublicRoute
        component={RecoverPassswordNewPasswordContainer}
        layout={PublicLayoutContainer}
        path={NEW_PASSWORD}
      />
      <PublicRoute
        component={EmailSentSuccessContainer}
        layout={PublicLayoutContainer}
        path={RECOVER_PASSWORD_SUCCESS}
      />
      <PublicRoute
        component={RecoverPasswordEmailContainer}
        layout={PublicLayoutContainer}
        path={RECOVER_PASSWORD}
      />
      <Redirect path={HOME} exact to={PROVIDER_ROOT} />
      <Route path="*">
        <h1>404 Not Found</h1>
      </Route>
    </Switch>
  );
};
